module.exports = __webpack_public_path__ + "img/intro_pc_img01.cae9e4ef.png";